module.exports = __webpack_public_path__ + "static/nn-9e7f4347e9a7bf31481426b224c510de.jpg";